export const addIfUnique = (acc: number[], item: number | null): number[] =>
  item ? (acc.includes(item) ? acc : [...acc, item]) : acc;
